import { SharingUrls } from '../store/schema/SharingLinkInfo';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';

export function getSharingUrls(response: GetSharingInfoResponse): SharingUrls {
    return <SharingUrls>{
        anonymousViewLink: response.AnonymousViewLink,
        anonymousEditLink: response.AnonymousEditLink,
        organizationViewLink: response.OrganizationViewLink,
        organizationEditLink: response.OrganizationEditLink,
    };
}
